import { render } from "./About.vue?vue&type=template&id=a361fc34&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=a361fc34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a361fc34"

export default script